function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 11h-6V5a1 1 0 00-2 0v6H5a1 1 0 000 2h6v6a1 1 0 002 0v-6h6a1 1 0 000-2z",
  "data-name": "plus"
}));

function SvgIconPlusOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9InBsdXMiPjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDEyIDEyKSIgb3BhY2l0eT0iMCIvPjxwYXRoIGQ9Ik0xOSAxMWgtNlY1YTEgMSAwIDAgMC0yIDB2Nkg1YTEgMSAwIDAgMCAwIDJoNnY2YTEgMSAwIDAgMCAyIDB2LTZoNmExIDEgMCAwIDAgMC0yeiIvPjwvZz48L2c+PC9zdmc+";
export { SvgIconPlusOutline as ReactComponent };